export default __webpack_public_path__ + "f4d5bff58c9872ff2e3b99f60c3de6e9.png";